import { FileText, RefreshCcw, Trash2, Upload } from "lucide-react";
import { type DragEvent, useId, useState } from "react";

const MAX_PDF_BYTES = 10 * 1024 * 1024;

export function validatePdfFile(candidate: File) {
  if (candidate.type !== "application/pdf" && !candidate.name.toLowerCase().endsWith(".pdf")) return "Seleccioná un archivo PDF válido.";
  if (candidate.size > MAX_PDF_BYTES) return "El PDF supera el límite de 10 MB.";
  return undefined;
}

export function PdfFilePicker({ file, onChange, loading = false, success = false, error }: {
  file: File | null;
  onChange: (file: File | null) => void;
  loading?: boolean;
  success?: boolean;
  error?: string;
}) {
  const id = useId();
  const [validation, setValidation] = useState<string>();
  const [dragging, setDragging] = useState(false);
  const select = (candidate?: File) => {
    if (!candidate) return;
    const issue = validatePdfFile(candidate);
    if (issue) {
      setValidation(issue);
      onChange(null);
      return;
    }
    setValidation(undefined);
    onChange(candidate);
  };
  return <div className="pdf-picker">
    <span className="field-label">Archivo PDF</span>
    <input id={id} className="visually-hidden" type="file" accept="application/pdf,.pdf" onChange={(event) => select(event.target.files?.[0])} />
    <div
      className={`pdf-dropzone${dragging ? " dragging" : ""}${file ? " has-file" : ""}`}
      onDragEnter={(event: DragEvent) => { event.preventDefault(); setDragging(true); }}
      onDragOver={(event: DragEvent) => event.preventDefault()}
      onDragLeave={() => setDragging(false)}
      onDrop={(event: DragEvent) => { event.preventDefault(); setDragging(false); select(event.dataTransfer.files?.[0]); }}
    >
      {file ? <div className="pdf-file-meta"><FileText size={20} /><span><strong title={file.name}>{file.name}</strong><small>{(file.size / 1024 / 1024).toFixed(2)} MB · PDF</small></span></div> : <div className="pdf-drop-copy"><Upload size={20} /><span><strong>Arrastrá un PDF acá</strong><small>o elegilo desde tu equipo · máximo 10 MB</small></span></div>}
      <div className="pdf-picker-row">
        <label htmlFor={id} className="secondary pdf-picker-button"><Upload size={16} />{file ? "Reemplazar PDF" : "Elegir archivo"}</label>
        {file && <button type="button" className="icon-button" aria-label="Quitar PDF seleccionado" title="Quitar PDF" onClick={() => { setValidation(undefined); onChange(null); }}><Trash2 size={16} /></button>}
      </div>
    </div>
    {loading && <div className="upload-state" role="status"><RefreshCcw className="spin" size={14} /> Cargando archivo…</div>}
    {success && !loading && <div className="upload-state success" role="status">PDF cargado correctamente.</div>}
    {(validation || error) && <div className="form-error" role="alert">{validation ?? error}</div>}
  </div>;
}
